import { useEffect, useState } from 'react';
import { sortArrList } from '../../../components/commonFunc';
import { getAllActivities } from '../../../providers/apis/blogApi';
import {
  getBlogGraphic2Url,
  getEventGraphic2Url,
  getNewsGraphic2Url,
  getPodcastGraphic2Url,
  resolveContentMedia,
} from '../helper/graphic2';
import { HubFeatureCard } from '../layout/HubFeatureCard';
import { HubListingView } from '../layout/HubListingView';
import { useFilteredHubListing } from '../layout/useFilteredHubListing';

function parseActivities(activities) {
  const blogs = activities.blogs.map((bItem) => ({
    postId: bItem.id,
    postType: bItem.Content_Type,
    title: bItem.Title,
    postDate: bItem.DateWritten,
    postMedia: resolveContentMedia(bItem, getBlogGraphic2Url),
    postName: bItem.Relevance,
    creator: bItem.Author,
    content: bItem.Description,
  }));

  const podcasts = activities.podcasts.map((pItem) => ({
    postId: pItem.id ?? pItem.Id,
    postType: pItem.ContentType,
    title: pItem.Title,
    postDate: pItem.DatePublished,
    postMedia: resolveContentMedia(pItem, getPodcastGraphic2Url),
    postName: pItem.Relevance,
    creator: pItem.Author,
    content: pItem.Description,
  }));

  const events = activities.events.map((eItem) => ({
    postId: eItem.id,
    title: eItem.Title,
    postMedia: resolveContentMedia(eItem, getEventGraphic2Url),
    postType: eItem.ContentType,
    postDate: eItem.LastUpdated,
    postName: eItem.Relevance,
    eventStartDate: eItem.StartDate,
    eventEndDate: eItem.EndDate,
    eventUrl: eItem.EventPath,
    addressData: {
      address: eItem.Address,
      country: eItem.Country,
      city: eItem.City,
      state: eItem.State,
      zip: eItem.Zip,
      phone: eItem.Phone,
    },
  }));

  const news = activities.news.map((nItem) => ({
    postId: nItem.Id,
    title: nItem.Title,
    postMedia: resolveContentMedia(nItem, getNewsGraphic2Url),
    postDate: nItem.DatePublished,
    postType: nItem.ContentType,
    postName: nItem.Relevance,
    link: nItem.Source,
    hasBody: nItem.hasBody,
    content: nItem.Description,
  }));

  return sortArrList(blogs.concat(podcasts).concat(events).concat(news));
}

export function ArticleCardList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    query,
    hasQuery,
    matchCount,
    firstItem,
    pageItems,
    totalPages,
    currentPage,
    onPageChange,
  } = useFilteredHubListing(items);

  useEffect(() => {
    const loadFeatured = async () => {
      setLoading(true);
      try {
        const activitiesRes = await getAllActivities();
        setItems(parseActivities(activitiesRes));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadFeatured();
  }, []);

  const renderFeatured = (item) => <HubFeatureCard firstBlog={item} />;

  return (
    <HubListingView
      title="Featured"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
      hasQuery={hasQuery}
      query={query}
      matchCount={matchCount}
    />
  );
}
